import { useEffect, useRef } from "react";

import { translate } from "@/core/i18n";
import { usePreferences } from "@/core/state/preferences";

import { mountBootWarp } from "./bootWarp";

export function BootScreen() {
  const locale = usePreferences((state) => state.locale);
  const host = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const node = host.current;
    if (!node) return;
    let dispose = () => {};
    try {
      dispose = mountBootWarp(node);
    } catch (error) {
      console.error(error);
    }
    return dispose;
  }, []);

  return (
    <div className="boot-screen" role="status" aria-live="polite" aria-busy="true">
      <div ref={host} className="boot-warp" aria-hidden="true" />
      <div className="boot-brand">
        <div className="brand-lockup"><span className="brand-mark">OwO!</span><span className="brand-product">Identity</span></div>
        <p className="boot-status">{translate(locale, "boot.loading")}</p>
      </div>
    </div>
  );
}
